/**
 * Validation rules mixin — backward-compatible wrapper around standalone rules.
 *
 * New code should import from '@/utils/validation' directly.
 * This mixin wraps the standalone functions for existing Options API components.
 */
import {
    required, requiredNoSpaces, requiredCheckbox,
    username, email, noSpecialChars,
    number, supplierCost, marginNumber, allowance, decoration,
    integer, zipCode, maxIntValue, maxLength, minLength,
    minValue, maxValue, percent, greaterThanZero,
    domain, url, oneOf,
} from '@/utils/validation'

export default {
    methods: {
        validateNotEmpty: required,
        validateNotSpaces: requiredNoSpaces,
        validateNotEmptyCheckbox: requiredCheckbox,
        validateUsername: username,
        validateEmail: email,
        validateNoSpecials: noSpecialChars,
        validateNumber: number,
        validateSupplierCost: supplierCost,
        validateMarginNumber: marginNumber,
        validateAllowance: allowance,
        validateDecoration: decoration,
        validateInteger: integer,
        validateZipCode: zipCode,
        validateLimit: maxIntValue,
        validateCharLimit: maxLength,
        validateCount: minLength,
        validateMin: minValue,
        validateMax: maxValue,
        validateOneOf: oneOf,
        validatePercent: percent,
        validateGreaterThanZero: greaterThanZero,
        validateDomain: domain,
        validateURL: url,
    }
}
